import React from "react";
import AgentManagementPage from "layouts/shared/AgentManagementPage";
import { useUserContext } from "context/UserContext";
import { useTranslation } from "react-i18next";

function AgentManagementBK() {
  const { role } = useUserContext() || {};
  const { t } = useTranslation("agentManagement");
  const title = role === "SP" ? t("titleSp") : t("titleBk");
  return <AgentManagementPage title={title} />;
}

export default AgentManagementBK;
